import InjectPropertiesRule from './InjectPropertiesRule'

export const iscPreset = (publicRuntimeConfig, extraConfig = {}) => [
  InjectPropertiesRule({
    brand: publicRuntimeConfig.brand.site,
    config: {
      imageSphere: publicRuntimeConfig.imageSphere,
      brightcove: publicRuntimeConfig.brightcove,
      wcs: publicRuntimeConfig.wcs
    },
    ...extraConfig
  })
]
